import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "language-selector-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "langauge-selector"
}
const _hoisted_5 = ["active", "disabled", "onClick"]
const _hoisted_6 = {
  key: 2,
  class: "error error--message"
}

import { onBeforeMount, onBeforeUnmount, onErrorCaptured, reactive } from 'vue';
    import { AppStore } from '@/stores/app';
    import { MenuStore } from '@/stores/menu';
    import { ShopStore } from '@/stores/shop';
    import { ApiStatus, Languages } from '@/types';
    import { useI18n } from 'vue-i18n';
    import axios from "axios";

    interface State {
        langauges: string[],
        status: ApiStatus,
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

    /* imports */
    const appStore = AppStore();
    const menuStore = MenuStore();
    const shopStore = ShopStore();
    const { t, locale } = useI18n();

    /* interface */
    const languages: Languages = {
        sv: 'Svenska',
        fi: 'Suomi',
        en: 'English',
        ru: 'Русский',
        no: 'Norsk'
    }

    /* Props */

    /* Ref */

    /* Reactive */
    const state = reactive<State>({
        langauges: [],
        status: {
            done: false,
            failed: false,
            loading: false
        }
    });


    /* Computed */

    /* Emits */

    /* AbortController */
    const abortController = new AbortController();

    /* Functions */

    const toggleLanguagePopup = () => {
        appStore.state.showLangSelector = true;
    };

    const setLang = (lang: string): void => {

        if (locale.value === lang) {
            return;
        }
        changeculture(lang)
            .then(() => {
                // Set locale value for i18n

                if (shopStore.id) {
                    menuStore.load(shopStore.id);
                }
                locale.value = lang;
                appStore.state.showLangSelector = false;
                document.documentElement.setAttribute("lang", locale.value);
            }).catch((err: Error) => {
                console.error('changeculture.catch', err.message);
                appStore.state.showLangSelector = false;
            });
    }

    const changeculture = async (lang: string) => {

        return new Promise((resolve: any, reject: any) => {
            
            axios.post<string>(`/api/cultures/changeculture?cultureCode=${lang}`)
                .then(response => response.data)
                .then(() => {
                    resolve(true);
                }).catch((err: Error) => {
                    reject(err);
                });
        });
    }

    const loadLanguages = async () => {
        state.status.loading = true;
        axios.get<string[]>(`/api/cultures/languages`)
        .then(response => response.data)
        .then((data: string[]) => {
            state.langauges = data;
            state.status.done = true;
        }).catch((err: Error) => {
            state.status.failed = true;
            state.status.text = err.message;
        }).finally(() => {
            state.status.loading = false;
        });
    }

    /* Lifecycle Hooks */
    onErrorCaptured(() => {
        appStore.state.showLangSelector = false;
    });

    onBeforeMount(() => loadLanguages());
    onBeforeUnmount(() => abortController.abort());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.status.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (state.status.done && !state.status.loading && state.langauges.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(appStore).state.isSmallScreen)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-link btn-lang",
                onClick: toggleLanguagePopup
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.langauges, (lang) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: lang,
                    class: "btn-link btn-link--lang",
                    active: (_unref(locale) === lang),
                    disabled: (_unref(locale) === lang),
                    onClick: ($event: any) => (setLang(lang))
                  }, _toDisplayString(languages[lang]), 9, _hoisted_5))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    (state.status.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('error.heading')), 1),
          _createElementVNode("p", null, _toDisplayString(state.status.text), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})